export { default as CustomHtml } from "./CustomHtml";

export enum EHtmlType {
  Text = "1",
  Custom = "2",
}
